export class LinkExpiredRequest {
    constructor(
        public userId: string,
        public code: string,
        public propertyContactInviteToken: string) {
    }

}